import React from 'react';

import type { CardsContentWithLink } from '../types';
import Buffer from './Buffer';
import Frequency from './Frequency';
import Frontload from './Frontload';
import Priority from './Priority';
import Status from './Status';
import Targeting from './Targeting';

export const lineItemsCardsContent: Array<CardsContentWithLink> = [
  {
    sideNavLink: 'Status',
    cardContent: (isExpanded, entityType): JSX.Element => <Status isExpanded={isExpanded} entityType={entityType} />,
  },
  {
    sideNavLink: 'Targeting',
    cardContent: (_, entityType): JSX.Element => <Targeting entityType={entityType} />,
  },
  {
    sideNavLink: 'Buffer',
    cardContent: (isExpanded): JSX.Element => <Buffer isExpanded={isExpanded} />,
  },
  {
    sideNavLink: 'Frontload',
    cardContent: (): JSX.Element => <Frontload />,
  },
  {
    sideNavLink: 'Priority',
    cardContent: (): JSX.Element => <Priority />,
  },
  {
    sideNavLink: 'Frequency',
    cardContent: (): JSX.Element => <Frequency />,
  },
];
